import * as actionType from './UserActionType';

export const downloadImportedFileRequest = (data) => ({
    type: actionType.DOWNLOAD_IMPORTED_FILE_REQUEST,
    payload: data,
});
export const downloadImportedFileSuccess = (data) => ({
    type: actionType.DOWNLOAD_IMPORTED_FILE_SUCCESS,
    payload: data,
});
export const downloadImportedFileFailure = (error) => ({
    type: actionType.DOWNLOAD_IMPORTED_FILE_FAILURE,
    payload: error,
});

export const fetchFileImportDetailsRequest = (data) => ({
    type: actionType.FETCH_FILE_IMPORT_DETAILS_REQUEST,
    payload: data,
});
export const fetchFileImportDetailsSuccess = (data) => ({
    type: actionType.FETCH_FILE_IMPORT_DETAILS_SUCCESS,
    payload: data,
});
export const fetchFileImportDetailsFailure = (error) => ({
    type: actionType.FETCH_FILE_IMPORT_DETAILS_FAILURE,
    payload: error,
});

export const getUsersRequest = (data) => ({
    type: actionType.GET_USERS_REQUEST,
    payload: data,
});
export const getUsersSuccess = (data) => ({
    type: actionType.GET_USERS_SUCCESS,
    payload: data,
});
export const getUsersFailure = (error) => ({
    type: actionType.GET_USERS_FAILURE,
    payload: error,
});

export const deleteUserRequest = (data) => ({
    type: actionType.DELETE_USER_REQUEST,
    payload: data,
});
export const deleteUserSuccess = (data) => ({
    type: actionType.DELETE_USER_SUCCESS,
    payload: data,
});
export const deleteUserFailure = (error) => ({
    type: actionType.DELETE_USER_FAILURE,
    payload: error,
});

export const getUserByIdRequest = (data) => ({
    type: actionType.GET_USER_BY_ID_REQUEST,
    payload: data,
});
export const getUserByIdSuccess = (data) => ({
    type: actionType.GET_USER_BY_ID_SUCCESS,
    payload: data,
});
export const getUserByIdFailure = (error) => ({
    type: actionType.GET_USER_BY_ID_FAILURE,
    payload: error,
});

export const saveUserRequest = (data) => ({
    type: actionType.SAVE_USER_REQUEST,
    payload: data,
});
export const saveUserSuccess = (data) => ({
    type: actionType.SAVE_USER_SUCCESS,
    payload: data,
});
export const saveUserFailure = (error) => ({
    type: actionType.SAVE_USER_FAILURE,
    payload: error,
});
export const exportUserRequest = (data) => ({
    type: actionType.EXPORT_USER_REQUEST,
    payload: data,
});

export const exportUserDataSuccess = (data) => ({
    type: actionType.EXPORT_USER_SUCCESS,
    payload: data,
});

export const exportUserDataFailure = (error) => ({
    type: actionType.EXPORT_USER_FAILURE,
    payload: error,
});
export const importUserRequest = (data) => ({
    type: actionType.IMPORT_USER_REQUEST,
    payload: data,
});

export const importUserDataSuccess = (data) => ({
    type: actionType.IMPORT_USER_SUCCESS,
    payload: data,
});

export const importUserDataFailure = (error) => ({
    type: actionType.IMPORT_USER_FAILURE,
    payload: error,
});

export const getUserActivityRequest = (data) => ({
    type: actionType.GET_USER_ACTIVITY_REQUEST,
    payload: data,
});
export const getUserActivitySuccess = (data) => ({
    type: actionType.GET_USER_ACTIVITY_SUCCESS,
    payload: data,
});
export const getUserActivityFailure = (error) => ({
    type: actionType.GET_USER_ACTIVITY_FAILURE,
    payload: error,
});

export const exportUserActivityRequest = (data) => ({
    type: actionType.EXPORT_USER_ACTIVITY_REQUEST,
    payload: data,
});
export const exportUserActivitySuccess = (data) => ({
    type: actionType.EXPORT_USER_ACTIVITY_SUCCESS,
    payload: data,
});
export const exportUserActivityFailure = (error) => ({
    type: actionType.EXPORT_USER_ACTIVITY_FAILURE,
    payload: error,
});

export const getUserAuthorizedMappingRequest = (data) => ({
    type: actionType.GET_USER_AUTHORIZED_MAPPING_REQUEST,
    payload: data,
});
export const getUserAuthorizedMappingSuccess = (data) => ({
    type: actionType.GET_USER_AUTHORIZED_MAPPING_SUCCESS,
    payload: data,
});
export const getUserAuthorizedMappingFailure = (error) => ({
    type: actionType.GET_USER_AUTHORIZED_MAPPING_FAILURE,
    payload: error,
});

export const toggleUserAuthorizedMappingRequest = (data) => ({
    type: actionType.TOGGLE_USER_AUTHORIZED_MAPPING_REQUEST,
    payload: data,
});
export const toggleUserAuthorizedMappingSuccess = (data) => ({
    type: actionType.TOGGLE_USER_AUTHORIZED_MAPPING_SUCCESS,
    payload: data,
});
export const toggleUserAuthorizedMappingFailure = (error) => ({
    type: actionType.TOGGLE_USER_AUTHORIZED_MAPPING_FAILURE,
    payload: error,
});

export const resetMFARequest = (data) => ({
    type: actionType.RESET_MFA_REQUEST,
    payload: data,
});
export const resetMFASuccess = (data) => ({
    type: actionType.RESET_MFA_SUCCESS,
    payload: data,
});
export const resetMFAFailure = (error) => ({
    type: actionType.RESET_MFA_FAILURE,
    payload: error,
});

export const resendWelcomeEmailRequest = (data) => ({
    type: actionType.RESEND_WELCOME_EMAIL_REQUEST,
    payload: data,
});
export const resendWelcomeEmailSuccess = (data) => ({
    type: actionType.RESEND_WELCOME_EMAIL_SUCCESS,
    payload: data,
});
export const resendWelcomeEmailFailure = (error) => ({
    type: actionType.RESEND_WELCOME_EMAIL_FAILURE,
    payload: error,
});

export const sendPendingWelcomeEmailsRequest = (data) => ({
    type: actionType.SEND_PENDING_WELCOME_EMAILS_REQUEST,
    payload: data,
});
export const sendPendingWelcomeEmailsSuccess = (data) => ({
    type: actionType.SEND_PENDING_WELCOME_EMAILS_SUCCESS,
    payload: data,
});
export const sendPendingWelcomeEmailsFailure = (error) => ({
    type: actionType.SEND_PENDING_WELCOME_EMAILS_FAILURE,
    payload: error,
});
